import { environment } from '~env/environment';

export const CUSTOMER_NEWSLETTER_CONSENT_URL_CRM = () =>
  `${environment.svcCrmBaseUrl()}/api/v1/public/exponea/customers/consent`;
export const CUSTOMER_EVENTS_URL_CRM = () =>
  `${environment.svcCrmBaseUrl()}/api/v1/public/exponea/customers/events`;
export const EXPONEA_COOKIE = '__exponea_etc__';
export const CUSTOMER_VISITORS_EVENT_URL_CRM = () =>
  `${environment.svcCrmBaseUrl()}/api/v1/public/exponea/visitors/event`;